import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon53: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M8.538.026c2.82.268 4.962 2.779 4.962 5.689V9.99h.491C15.1 9.992 16 10.892 16 12v4.019a3.973 3.973 0 0 1-3.973 3.973H3.973A3.973 3.973 0 0 1 0 16.019v-4.02c0-1.108.9-2.007 2.009-2.007L2.5 9.99V5.5A5.5 5.5 0 0 1 8.538.026Zm5.453 10.966h-.957c-.011.002-.023.002-.034.002l-.034-.003-1.932.002H11l-.034-.002H2.009C1.452 10.992 1 11.444 1 12v4.019a2.973 2.973 0 0 0 2.973 2.973h8.054A2.973 2.973 0 0 0 15 16.019v-4.02c0-.556-.452-1.007-1.009-1.007ZM8 12.994a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5ZM3.5 5.5v4.49h1V5.495a3.5 3.5 0 1 1 7 0V9.99h1V5.715c0-2.408-1.764-4.475-4.056-4.694A4.501 4.501 0 0 0 3.5 5.5ZM8 2.994a2.5 2.5 0 0 0-2.5 2.5V9.99h5V5.494a2.5 2.5 0 0 0-2.5-2.5Z"
      />
    </Svg>
  )
}
